<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

// Components
import AddOnLabel from '@/Components/AddOnLabel.vue';
import PackageItem from '@/Components/Blocks/Package/PackageItem.vue';

const props = defineProps({
    title: String,
    packages: Array,
    addOnLabel: Boolean,
});

const moduleActive = computed(() => usePage().props.template_options.modules.packages_component_active);
</script>

<template>
    <div :class="{ ' relative ': addOnLabel }">
        <div class="container py-12 md:py-16" v-if="moduleActive && packages">
            <AddOnLabel v-if="addOnLabel" />
            <div>
                <h2 class="" v-html="title" v-if="title"></h2>

                <div class="relative z-20">
                    <div class="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
                        <PackageItem v-for="(item, index) in packages" :index="index" :item="item" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
